import type { StoryblokRichTextDocumentNode } from '@storyblok/richtext';

// Recursively cleans Storyblok internal links in rich text content
export const sanitizeRichTextLinks = (
    richText: StoryblokRichTextDocumentNode,
    linkPrefix: string
): StoryblokRichTextDocumentNode => {
    const cleanHref = (href: string): string => {
        let result = href.replace(/\/{2,}/g, '/');
        if (!result.startsWith('/')) result = '/' + result;

        const pattern = new RegExp(`^/${linkPrefix}/pages/`, 'i');
        result = result.replace(pattern, '/');

        // TEMP FIX: prepend 'uk' locale to internal links for JP if missing
        if (linkPrefix === 'jp') {
            const hasLocalePrefix = result.startsWith('/uk/');
            const isInternalLink =
                !result.startsWith('http://') && !result.startsWith('https://') && !result.startsWith('//');

            if (isInternalLink && !hasLocalePrefix) {
                result = `/uk${result}`;
            }
        }

        return result;
    };

    const deepClone: StoryblokRichTextDocumentNode = JSON.parse(JSON.stringify(richText));

    const sanitizeLinkMarks = (node: StoryblokRichTextDocumentNode[]) => {
        const nodes = Array.isArray(node) ? node : [node];

        nodes.forEach((n) => {
            n.marks?.forEach((mark) => {
                if (mark.type === 'link' && mark.attrs?.href && mark.attrs?.linktype !== 'email') {
                    const href = mark.attrs.href;
                    if (!href.startsWith('http://') && !href.startsWith('https://')) {
                        mark.attrs.href = cleanHref(href);
                    }
                }
            });

            if (n.content) {
                sanitizeLinkMarks(n.content);
            }
        });
    };

    sanitizeLinkMarks(deepClone.content || []);
    return deepClone;
};
